<template>
  <auth-layout title="Forgot Password">
    <div class="mx-auto w-full max-w-[360px]">
      <div>
        <h1 class="text-3xl font-semibold text-gray-900 mb-3">
          {{ t("auth.forgot_password.title") }}
        </h1>
        <p class="text-tertiary text-base">
          {{ t("auth.forgot_password.sub_title") }}
          <Link
            class="font-medium text-blue-600 hover:underline"
            :href="route('login')"
            >{{ t("auth.forgot_password.login") }}</Link
          >
          {{ t("auth.forgot_password.instead") }}
        </p>
      </div>
      <form @submit.prevent="submit" class="mt-10 grid grid-cols-1 gap-y-8">
        <div class="">
          <label
            for="email"
            class="mb-3 block text-sm font-medium text-gray-700"
          >
            {{ t("auth.forgot_password.email_address") }} </label
          ><input
            id="email"
            type="email"
            name="email"
            autocomplete="email"
            v-model="form.email"
            class="block w-full appearance-none rounded-sm border border-gray-200 bg-gray-50 px-3 py-2 text-gray-900 placeholder-gray-400 focus:bg-white focus:outline-none focus:ring-blue-500 sm:text-sm"
          />
          <p
            v-if="form.errors.email"
            class="mt-2 text-sm text-red-600"
            id="email-error"
          >
            {{ form.errors.email }}
          </p>
        </div>
        <div>
          <Button
            class="w-full rounded-md bg-dark-blue-700 focus:outline-none p-4 text-white font-semibold text-base capitalize"
            type="submit"
            :label="t('auth.forgot_password.reset_password')"
            size="lg"
          >
            <template #end>
              <Icon name="arrow-long-right" />
            </template>
          </Button>
        </div>
      </form>
    </div>
  </auth-layout>
</template>

<script setup>
import AuthLayout from "@/Tailwind/AuthLayout";
import { useForm, Link, usePage } from "@inertiajs/vue3";
import route from "ziggy-js";
import { onMounted } from "vue";
import { useBrowserLocale } from "@/Tailwind/Mixins/useBrowserLocale";
import { useI18n } from "vue-i18n";

import { Button } from "@/SharedComponents/Buttons";
import { Icon } from "@/SharedComponents/Icon";

const i18n = useI18n();
const t = i18n.t;

const defaultLocale = usePage().props.locale;
const browserLocale = useBrowserLocale(i18n, defaultLocale);

const form = useForm({
  email: null,
});

const submit = () => {
  form.post(route("password.email"));
};

onMounted(() => {
  // Set the current language as the prefered browser language
  i18n.locale.value = browserLocale;
});
</script>
